import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../../core/services/admin.service';
import { environment } from '../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { FreightClaimService } from '../../../../core/services/freight-claim.service';
@Component({
  selector: 'app-partner-pak-training',
  templateUrl: './partner-pak-training.component.html',
  styleUrls: ['./partner-pak-training.component.scss']
})
export class PartnerPakTrainingComponent implements OnInit {

  description: string = ""; 
  pdfUrl: string = "";
  pdfLinkLbl: string = "";
  pdfViewerUrl: any=null;
  constructor(private adminService: AdminService, private sanitizer: DomSanitizer, private freightClaimService: FreightClaimService) { }

  ngOnInit() {
    this.pdfLinkLbl = "Click here to download PDF";
    this.pdfUrl = environment.imageUrl+"/ResourceCenter/content/KawneerTrainingWaiver.pdf";
    const body = {
      trainingType: "partnerPakTraining",
      languageCode: localStorage.getItem("language")
    }
    this.adminService.getTrainingPagesDescription(body).subscribe(response => {
      if (response.length > 0) {
        if (response[0].description) {
          this.description = response[0].description;
        }
        else if (response[0].urlPath) {
          const url = environment.imageUrl + response[0].urlPath;
          this.pdfViewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
      }
    })
  }
  public openDocument(pathName: any) {
    const body = {
      Url: pathName,
    }
    this.freightClaimService.getDocument(body).subscribe((response) => {
      if (response) {
        console.log(response);
        const blob: Blob = (response && (response as any).body)
          ? (response as any).body
          : (response as Blob);
        if (blob) {
          console.log(blob.type);
          const fileName = 'download';
          //const fileName = ((child && child.partNo) ? partNo : 'download');
          const url = window.URL.createObjectURL(blob);
          window.open(url, '_blank');
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 5000)
        }
      }
    });
  }
}
